<script>
import { createPopper } from '@popperjs/core'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({
        placement: 'bottom-end'
      })
    }
  },
  data() {
    return {
      isVisible: false,
      popper: null
    }
  },
  mounted() {},
  methods: {
    show() {
      this.isVisible = true
      this.$nextTick(() => {
        const trigger = this.$refs.trigger
        const content = this.$refs.content

        this.popper = createPopper(trigger, content, this.options)
        this.popper.forceUpdate()
      })
    },
    hide() {
      this.isVisible = false
      this.popper.destroy()
    }
  }
}
</script>

<template>
  <div class="popover">
    <div class="popover-trigger" ref="trigger" @click="show()">
      <slot :isVisible="isVisible" />
    </div>
    <div
      class="popover-content mt-1"
      ref="content"
      v-click-outside="hide"
      v-if="isVisible"
    >
      <slot name="content" :show="show" :hide="hide" />
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/_functions.scss';
@import '@/styles/_settings.scss';

.popover-content {
  position: relative;
  background: white;
  padding: 4px;
  border: 1px solid $gray-400;
  border-radius: $border-radius;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    margin-left: -5px;
    display: block;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom-color: $gray-400;
  }

  &:after {
    top: -9px;
    border-bottom-color: white;
  }

  &[data-popper-placement~='bottom-end'] {
    &::before,
    &::after {
      left: auto;
      right: 14px;
    }
  }

  &[data-popper-placement~='bottom-start'] {
    &::before,
    &::after {
      left: 14px;
    }
  }
}
</style>
